import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const XmlViewerAndroid: React.FC = () => (
  <SEOLandingPage
    title="XML Viewer for Android — View, Parse & Edit XML on Your Phone | Cosmovex"
    metaDescription="XMLVEdit is an XML viewer and editor for Android. Open XML files, browse the tree structure, validate syntax, and edit directly on your phone."
    ogTitle="XML Viewer for Android — XMLVEdit"
    h1="XML Viewer for Android"
    intro="Open XML files on your Android phone and navigate them like a pro. XMLVEdit renders the tree structure, validates syntax, and lets you edit — all on mobile."
    paragraphs={[
      "XML is the data format behind Android manifests, Maven POM files, SVGs, SOAP APIs, configuration files, and more. XMLVEdit gives Android users a proper way to view and navigate these files — not as a wall of text, but as a parsed, collapsible tree that makes structure obvious at a glance.",
      "The tree view is the heart of XMLVEdit. Every XML element becomes a node you can expand or collapse. Attributes show inline. Text content is readable. You can navigate deeply nested structures quickly, search for specific elements, and jump to the line in the raw source that corresponds to any node in the tree.",
      "Validation happens in real time. As you edit, XMLVEdit checks for well-formedness errors — unclosed tags, malformed attributes, encoding issues — and highlights them immediately. For developers working with API responses, configuration files, or Android resource XMLs, catching a parse error before it reaches production is valuable.",
      "XMLVEdit also handles large XML files gracefully. Files that would crash a simple text editor load quickly because XMLVEdit parses and streams the content, only rendering what's visible on screen. For log files and data exports that run into megabytes, this matters.",
    ]}
    features={[
      "Collapsible XML tree view for structured navigation",
      "Syntax highlighting in raw edit mode",
      "Real-time XML validation and error highlighting",
      "XPath search to find elements quickly",
      "Handle large XML files efficiently",
      "Format and prettify minified XML",
      "Minify XML to reduce file size",
      "Edit and save modified XML to device",
      "Share formatted XML via other apps",
      "Supports UTF-8, UTF-16, and common encodings",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.xmlvedit"
    icon="/images/javavedit.png"
    appName="XMLVEdit"
    accentColor="#A8720E"
    canonicalPath="/xml-viewer-android"
  />
);

export default XmlViewerAndroid;
